import { useState } from 'react';
import { CaretUp, CaretDown, PiggyBank } from '@phosphor-icons/react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { transformMaskCurrency } from '../../../../../../../utils/transformMaskCurrency';
import { filterTableSorte } from '../../../../../../../utils/filterTableSort';
import { IPropsAllPosition } from '../..';
import {
  CaretDown as ArrowDown,
  CaretUp as ArrowUp,
} from '@phosphor-icons/react';
import {
  Money,
  HandCoins,
  ShieldPlus,
  Car,
  HouseLine,
  AirplaneTilt,
  Wrench,
  Student,
  Tag,
  HandHeart,
  UserCircle,
  ChartLineUp,
  Briefcase,
  DeviceMobile,
  DesktopTower,
  Heartbeat,
  PawPrint,
  GraduationCap,
  PlusCircle,
  DotsThreeCircleVertical,
  DotsThreeVertical,
  Medal,
} from '@phosphor-icons/react';
import axios from 'axios';
import { baseURL } from '../../../../../../../utils/baseURL';
import { financeRoutes } from '../../../../../../../utils/RoutesApi';
import { EditActive } from '../../../../../../pages/Wallet/Tabs/ManualImport/styles';
import ModalUpdateFixedIncome from '../ModalUpdateFixedIncome';
import { cloneElement } from 'react';

interface IPropsTableSelectedMattress {
  header: {
    label: string;
    active?: string;
  }[];
  dataTable: PositionWithObjectives[];
  ASC: Function;
  DESC: Function;
  onSubmitUpdateMattress: (id: string) => void;
  handleUpdate: () => Promise<void>;
  onBoxRefresh?: () => Promise<void>;
}

// src/types/objectives.ts
type ObjectiveRef = {
  id: string;
  name: string;
  icon: string;
  box_applied_value?: number;
};

type PositionWithObjectives = IPropsAllPosition & {
  objectives?: ObjectiveRef[];
  grossAmount?: number;
  netValue?: number;
};

const StyledTableContainer = styled(TableContainer)(() => ({
  borderRadius: 8,
  border: '1px solid #E0E0E0',
  boxShadow: 'none',
  maxHeight: 500,
}));

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#E6EBEF',
    color: '#40444C',
    fontWeight: 600,
    fontSize: '0.9rem',
    fontFamily: 'Poppins, sans-serif',
    padding: '10px 14px',
    borderBottom: '1px solid #ddd',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '0.9rem',
    color: '#444',
    fontFamily: 'Poppins, sans-serif',
    padding: '12px 14px',
    borderBottom: '1px solid #f0f0f0',
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#FAFAFA',
  },
  '&:hover': {
    backgroundColor: '#F0F7FF',
  },
}));

export function TableSelectedMattress({
  header,
  dataTable,
  ASC,
  DESC,
  handleUpdate,
  onBoxRefresh,
}: IPropsTableSelectedMattress) {
  const [attOrdemTable, setAttOrdemTable] = useState<boolean>(false);
  const [expandedRow, setExpandedRow] = useState<string | null>(null);
  const [modalEdit, setModalEdit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [selected, setSelected] = useState<{
    totalApplied?: number;
    updatedTotal: number;
    id: string;
  } | null>(null);
  const isUuid = (s?: string) =>
    !!s &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      s
    );

  const toggleRow = (id: string) => {
    setExpandedRow(expandedRow === id ? null : id);
  };
  const icons = [
    {
      name: 'plus',
      element: <ShieldPlus size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'money',
      element: <PiggyBank size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'car',
      element: <Car size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'house',
      element: <HouseLine size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'airplane',
      element: <AirplaneTilt size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'wrench',
      element: <Wrench size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'student',
      element: <Student size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'tag',
      element: <Tag size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'ring',
      element: <HandHeart size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'retirement',
      element: <UserCircle size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'chart',
      element: <HandCoins size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'briefcase',
      element: <Briefcase size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'phone',
      element: <DeviceMobile size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'computer',
      element: <DesktopTower size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'health',
      element: <Heartbeat size={24} width="20" height="20" fill="#6A717E" />,
    },
    {
      name: 'pet',
      element: <PawPrint size={24} width="20" height="20" fill="#6A717E" />,
    },
  ];



  const getIconByName = (name: string) => {
    if (!name) return null;
    const icon = icons.find((i) => i.name === name);

    if (!icon) {
      return (
        <ChartLineUp
          size={20}
          color="#6A717E"
          aria-label="Investimento"
          alt="Investimento"
        />
      );
    }

    return cloneElement(icon?.element, {
      'aria-label': name,
      title: name,
    });
  };

  const getAppliedValue = (item: PositionWithObjectives) => {
    const tipo = String(item.productTypeName || '').toLowerCase();
    const quantity = Number(item.equitiesQuantity || 0);
    const price = Number(item.closingPrice || 0);

    if (item.appliedValue && item.appliedValue > 0) return item.appliedValue;
    if (item.applicationValue && item.applicationValue > 0) return item.applicationValue;

    if (['tesourodireto', 'rendafixa', 'renda fixa'].includes(tipo)) {
      // se quantity for menor que 100, é quantidade de título
      if (quantity > 0 && quantity < 100 && price > 0) {
        return quantity * price;
      }

      // se vier grande, já é valor aplicado
      return quantity;
    }

    return quantity * price;
  };

  // const getIconByName = (name: string) =>
  //   icons.find((i) => i.name === name)?.element;
  const formatDate = (dateString?: string | null) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };
  const handleUpdateFixedIncomeUpdateValue = async (valueUpdated: string, valueApplied?: string) => {
    setLoading(true);
    const payload: {
      key: string | undefined;
      valueUpdated: number | null;
      valueApplied: number | null;
    } = {
      key: selected?.id,
      valueUpdated: null,
      valueApplied: null
    }
    if (valueApplied){
      payload.valueApplied = Number(valueApplied)
    }
    if (valueUpdated) {
      payload.valueUpdated = Number(valueUpdated)
    }
    await axios.post(`${baseURL}${financeRoutes.FINANCE_FIXED_INCOME_UPDATE}`, payload);
    await handleUpdate();
    if (onBoxRefresh) await onBoxRefresh();
    setLoading(false);
    setModalEdit(false);
  };
  return (
    <StyledTableContainer>
      <Table stickyHeader aria-label="customized table">
        <TableHead>
          <TableRow>
            {header.map((item) => (
              <StyledTableCell key={item.label}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '8px',
                  }}
                >
                  {item.label}
                  {item.active && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        lineHeight: 0.8,
                      }}
                    >
                      <CaretUp
                        size={14}
                        color="#333"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setAttOrdemTable(!attOrdemTable);
                          ASC(
                            filterTableSorte({
                              data: dataTable,
                              dir: 'asc',
                              //@ts-ignore
                              key: item.active,
                            })
                          );
                        }}
                      />
                      <CaretDown
                        size={14}
                        color="#333"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setAttOrdemTable(!attOrdemTable);
                          DESC(
                            filterTableSorte({
                              data: dataTable,
                              dir: 'desc',
                              //@ts-ignore
                              key: item.active,
                            })
                          );
                        }}
                      />
                    </div>
                  )}
                </div>
              </StyledTableCell>
            ))}
            <StyledTableCell /> {/* Coluna do botão */}
          </TableRow>
        </TableHead>

        <TableBody>
          {dataTable.length > 0 ? (
            dataTable.map((item) => {
              const isExpanded = expandedRow === item.tickerSymbol;
              // const totalValue = Number(item.updateValue ?? 0);

              const totalAppliedInBoxes = Number(item.total_investment_box_applied_value ?? 0);
              // const appliedInBoxes =
              //   item.objectives?.reduce(
              //     (sum, obj) => sum + (item.total_investment_box_applied_value ?? 0),
              //     0
              //   ) ?? 0;

              // valor total real do ativo
              const totalCurrentValue = Number(item.updateValue ?? 0) + totalAppliedInBoxes;
              
              // sobra fora das boxes
              const remainingValue = totalCurrentValue - totalAppliedInBoxes;

              const hasRemainingValue = remainingValue > 0.01;
              //const hasRemainingValue = totalValue - appliedInBoxes > 0.01
              // console.log('remain',hasRemainingValue)

              // Ativo 100% alocado em boxes (box_applied_percentage == 1) não
              // exibe o ícone de investimento livre na coluna de objetivos.
              const boxAppliedPct = Number(item.box_applied_percentage ?? 0);
              const showInvestmentIcon = hasRemainingValue && boxAppliedPct < 1;

              const validObjectives = item.objectives ?? [];
              // console.log('ROW', {
              //   ticker: item.tickerSymbol,
              //   key: item.key,
              //   id: (item as any).id,
              //   productType: item.productTypeName,
              // });

              return (
                <>
                  <StyledTableRow key={item.tickerSymbol}>
                    <StyledTableCell>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: 6,
                          flexWrap: 'wrap',
                        }}
                      >
                        <>
                          {/* {validObjectives ?? 0 ? ( */}
                          {validObjectives.length > 0 ? (
                            <>
                              {validObjectives.map((obj) => (
                                <span key={obj.id} title={obj.name}>{getIconByName(obj.icon)}</span>
                              ))}
                              {showInvestmentIcon && <ChartLineUp color="#6A717E" size={20} alt='Investimento'/>}
                            </>
                          ) : (
                            showInvestmentIcon && <ChartLineUp color="#6A717E" size={20} alt='Investimento'/>
                          )}

                        </>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>{item.tickerSymbol}</StyledTableCell>
                    <StyledTableCell>
                      {item.corporationName
                        ? item.corporationName.charAt(0).toUpperCase() +
                          item.corporationName.slice(1)
                        : '-'}
                    </StyledTableCell>
                    {/* valor aplicado */}
                    <StyledTableCell>
                      {transformMaskCurrency(getAppliedValue(item))}
                    </StyledTableCell>
                    <StyledTableCell>
                      {transformMaskCurrency(
                        item?.manual_update_value || (item.updateValue + item.total_investment_box_applied_value)
                      )}
                    </StyledTableCell>
                    <StyledTableCell>
                      {formatDate(item.expirationDate)}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {/* <ArrowUp
                        size={18}
                        color="#444"
                        style={{ cursor: 'pointer' }}
                        onClick={() => toggleRow(item.tickerSymbol)}
                      /> */}
                      {(item as any).id?.includes('fixed_income') ||
                      isUuid((item as any).id) ? (
                        <EditActive
                          onClick={() => {
                            setModalEdit(true);
                            setSelected({
                              totalApplied: getAppliedValue(item),
                              updatedTotal: item?.manual_update_value || (item.updateValue + item.total_investment_box_applied_value),
                              id: (item as any).id,
                            });
                          }}
                        />
                      ) : (
                        '-'
                      )}
                    </StyledTableCell>

                    <StyledTableCell align="center">
                      {isExpanded ? (
                        <ArrowUp
                          size={18}
                          color="#444"
                          style={{ cursor: 'pointer' }}
                          onClick={() => toggleRow(item.tickerSymbol)}
                        />
                      ) : (
                        <ArrowDown
                          size={18}
                          color="#444"
                          style={{ cursor: 'pointer' }}
                          onClick={() => toggleRow(item.tickerSymbol)}
                        />
                      )}
                    </StyledTableCell>
                  </StyledTableRow>

                  {isExpanded && (
                    <TableRow>
                      <TableCell
                        colSpan={header.length + 1}
                        style={{
                          backgroundColor: '#F9FAFB',
                          padding: '8px 16px',
                          borderTop: '1px solid #eee',
                          marginBottom: '0',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '2px',
                            fontSize: '0.9rem',
                            color: '#333',
                            fontFamily: 'Poppins, sans-serif',
                            marginBottom: '0',
                          }}
                        >
                          <strong>{item.tickerSymbol}</strong>
                          <div className="infos-tabela">
                            <p className="tableInfos">
                              <b>Índice: </b>
                              {item.corporationName}
                            </p>

                            <p className="tableInfos">
                              <b>Corretora:</b>
                              {item.bookkeeperName}
                            </p>
                            <p className="tableInfos">
                              <b>Valor aplicado:</b>
                              {transformMaskCurrency(getAppliedValue(item))}
                            </p>
                            <p className="tableInfos">
                              <b> Valor bruto atualizado:</b>
                                {transformMaskCurrency(item.grossAmount ?? item.updateValue ?? 0)}
                            </p>
                            <p className="tableInfos">
                              <b>Valor líquido:</b>
                                {transformMaskCurrency(item.netValue ?? 0)}
                            </p>
                            <p className="tableInfos">
                              <b>Vencimento:</b>{' '}
                              {formatDate(item.expirationDate ?? '-')}
                            </p>
                            <p className="tableInfos">
                              <b>Quantidade:</b> {item.equitiesQuantity}
                            </p>
                          </div>

                          {/* <strong>{item.tickerSymbol}</strong>
                          <div className='infos-tabela'>
                            <p className='tableInfos'><b>Índice: </b>{item.corporationName}</p>
                            <p className='tableInfos'><b>Corretora: </b>{item.bookkeeperName}</p>
                            <p className='tableInfos'><b>Rentabilidade contratada: </b> 0.04% a.a.</p>
                            <p className='tableInfos'><b>Valor aplicado: </b> {transformMaskCurrency(item.availableQuantity ?? 0)}</p>
                            <p className='tableInfos'><b>Valor bruto atualizado: </b> {transformMaskCurrency(item.updateValue)}</p>
                            <p className='tableInfos'><b>Valor líquido: </b> {transformMaskCurrency(item.closingPrice)}</p>
                            <p className='tableInfos'><b>Vencimento: </b> {formatDate(item.expirationDate)}</p>
                            <p className='tableInfos'><b>Quantidade: </b> {item.equitiesQuantity}</p>
                          </div> */}
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </>
              );
            })
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={header.length}
                style={{ textAlign: 'center' }}
              >
                Ainda não há dados
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {modalEdit && (
        <ModalUpdateFixedIncome
          onClose={() => {
            setModalEdit(false);
          }}
          loading={loading}
          totalApplied={selected?.totalApplied || undefined}
          updatedTotal={selected?.updatedTotal || undefined}
          onCreate={handleUpdateFixedIncomeUpdateValue}
        />
      )}
    </StyledTableContainer>
  );
}
